import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_LegalBasis3BasicRolandDe } from '@flows/insurance/schemas'

const legal_previous_insurance_carrier = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('previous_insurer')]:
        BaseSchema_LegalBasis3BasicRolandDe.shape.previous_insurer.unwrap(),
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_legal:steps.legal_3.previous_insurance_carrier.title',
        },
      },
      {
        type: 'customComponent',
        shouldTrackValues: true,
        name: 'PreviousInsurerInput',
        props: {
          productKey: params.productKey,
        },
        inputs: [],
        outputs: [params.helperFunctions.getParamPath('previous_insurer')],
      },
    ],
    subFlow: params.subFlow,
    onPrepare: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'fetchProductConfigurationOptions',
        options: {
          productKey: params.productKey,
        },
        inputs: [],
        outputs: [],
      },
    },
    nextStep: 'legal_claims_free',
  }) as const satisfies AnyStepConfiguration

export default legal_previous_insurance_carrier
